module.exports = __webpack_public_path__ + "static/img/product3new.a872edce.png";